import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { isSameTenantTabNavigation } from '@/router/routeViewKey'

export function useRouteProgress() {
  const progress = ref(0)
  const visible = ref(false)
  let t: ReturnType<typeof setInterval> | null = null

  const router = useRouter()

  router.beforeEach((to, from) => {
    if (isSameTenantTabNavigation(from, to)) {
      return
    }

    visible.value = true
    progress.value = 10
    if (t) clearInterval(t)
    t = setInterval(() => {
      progress.value = Math.min(progress.value + 12, 90)
    }, 120)
  })

  router.afterEach((to, from) => {
    if (isSameTenantTabNavigation(from, to)) {
      return
    }

    if (t) {
      clearInterval(t)
      t = null
    }
    progress.value = 100
    setTimeout(() => {
      visible.value = false
      progress.value = 0
    }, 200)
  })

  return { progress, visible }
}
